import { jsx as _jsx } from "react/jsx-runtime";
import { ConversationId } from 'components/conversation/conversationId';
import { useConversationRow } from '../../../utils/useConversationRow';
/** Represents the content of the csid cell in the conversations table. */
export const ConversationsTableCsid = () => {
    const { conversationAndRequester: { conversation }, } = useConversationRow();
    return _jsx(ConversationId, { csid: conversation.id });
};
